import { Button, IconButton } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HermesRating from "../chatbot/bot/bot_utility_components/HermesRating";
// import CancelIcon from "@material-ui/icons/Cancel";
import MinimizeIcon from "@material-ui/icons/Minimize";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./ConfirmModal.css";
import { makeStyles } from "@material-ui/core/styles";
import AdyaRating from "../chatbot/indianbank/adya_utility_components/AdyaRating";
import AdyaRatingSubmit from "../chatbot/indianbank/adya_utility_components/AdyaRatingSubmit";
import cancel from "../../../src/images/Vector.svg"

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

export default function ConfirmModal(props) {
  //Subscribing to selected redux states
  // const confirmModal = useSelector((state) => state.confirmModal);
  // const dispatch = useDispatch();
  const classes = useStyles();

  const [lazyLoading, setlazyLoading] = useState(false);
  // const [show, setShow] = useState(true);

  // const onConfirm = () => {
  //   setlazyLoading(true);
  //   props.onConfirm();
  // };
  return (
    <>
      <div className="confirmModalWrapper">
        <div className="confirmModalContent">
          {/*
      Feedback:
        We would really appreciate your feedback.
        How would you like to rate your overall experience? 
       */}
          {/* <Button style={{paddingRight:14}} variant="outlined" size="small" disabled={lazyLoading} onClick={onConfirm} color="secondary">Terminate</Button>
      <Button style={{paddingRight:15}}variant="outlined" size="small" disabled={lazyLoading} onClick={props.onMinimize} color="primary">Minimize</Button>
      <Button style={{paddingRight:14}} variant="outlined" size="small" disabled={lazyLoading} onClick={props.onCancel} color="secondary">Cancel</Button> */}

          <div className={classes.root}>
            {/* Cancel */}
            {/* <IconButton
              style={{ paddingRight: 3, left: "71%" }}
              size="small"
              color="primary"
              aria-label="cancel"
              disabled={lazyLoading}
              // onClick={props.onCancel}
              // onClick={props.onMinimize}
              onClick={(e) => {
                setShow(false);
              }}
            >
              <ExpandMoreIcon />
            </IconButton> */}

            {/* Terminate */}
            {/* style={{ paddingRight: 3, left: "70%" }} */}
            <IconButton
              style={{ paddingRight: 3, left: "85%" }}
              size="small"
              color="secondary"
              aria-label="cancel"
              disabled={lazyLoading}
              onClick={props.onCancel}
              title="Close"
            >
              {/* <CancelIcon /> */}
              <img src={cancel}></img>
            </IconButton>
          </div>

          <div className="adyarating">
            {/* <AdyaRating /> */}
            <AdyaRatingSubmit />
          </div>
        </div>
        {/* {lazyLoading && (
          <>
            <div className="confirmLazyWrapper">
              <div class="ConfirmModalLoads"></div>
            </div>
          </>
        )} */}
      </div>
    </>
  );
}
